<template>
    <div class="top-menu" :class="[
        {
            'colorType': colorType === 'black' || (colorType === 'normal' && scrollDistance > 200)
        },
        { 'isTop': scrollDistance > 0 },
        { 'isBlack': colorType === 'black' },
        { 'isWhite': colorType === 'white' },
        { 'isTopWhite': scrollDistance > 0 && colorType === 'white' }
    ]">
        <div class="top-menu-inner">
            <a class="logo-img-link" :href="linkFlag ? '/' : ''" @click="linkFlag || $event.preventDefault()" rel="nofollow">
                <img v-if="colorType === 'black' || (colorType === 'normal' && scrollDistance > 200) || (colorType === 'normal' && scrollDistance > 0 && isMobile)"
                    class="top-menu-logo" src="../../assets/image/topMenu/logo_row_zh_CN.svg" alt="ebc">
                <img v-else class="top-menu-logo" src="../../assets/image/topMenu/logo_row_write_zh_CN.svg" alt="ebc">
            </a>
            <div class="link-box section-pc">
                <template v-for="(item, index) in linkList">
                    <a :key="item.target" :href="'#' + item.target">{{ item.name }}</a>
                    <div v-if="index < linkList.length - 1" :key="`line-${index}`" class="link-line"></div>
                </template>
            </div>
            <div class="section-mobile">
                <el-dropdown>
                    <span class="iconfont icon-navigate-menu"></span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="item in linkList" :key="item.target">
                            <a :href="'#' + item.target">{{ item.name }}</a>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'TopMenu',
    props: {
        colorType: {
            type: String,
            default: 'normal' // normal, black, white
        },
        linkList: {
            type: Array,
            default: () => []
        },
        linkFlag: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            scrollDistance: 0,
            isMobile: false,
            logos: null
        };
    },
    computed: {
        logoSrc() {
            const lang = this.$t("topMenu.imgLink");

            // 注意：Vue 2 中不能直接使用 import.meta.glob
            // 需要在 mounted 或 created 中加载资源
            if (!this.logos) {
                return {
                    normal: '',
                    white: ''
                };
            }

            const key1 = `logo_row_${lang}.svg`;
            const key2 = `logo_row_write_${lang}.svg`;

            return {
                normal: this.logos[key1] || '',
                white: this.logos[key2] || ''
            };
        }
    },
    mounted() {
        // this.loadLogos();

        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', this.handleScroll);
            // 初始化滚动距离
            this.scrollDistance = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

            this.checkScreen(); // 初始化
            window.addEventListener('resize', this.checkScreen);
        }
    },
    beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('scroll', this.handleScroll);
            window.removeEventListener('resize', this.checkScreen);
        }
    },
    methods: {
        // 自定义节流函数
        throttle(func, delay) {
            let timer = null;
            let lastArgs = null;
            let lastThis = null;
            let hasPendingCall = false;

            return function (...args) {
                // 保存最后一次调用的参数
                lastArgs = args;
                lastThis = this;
                hasPendingCall = true;

                if (!timer) {
                    // 立即执行第一次调用
                    func.apply(this, args);
                    hasPendingCall = false;
                    timer = setTimeout(() => {
                        timer = null;
                        // 执行最后一次调用（如果在延迟期间有新的调用）
                        if (hasPendingCall && lastArgs !== null) {
                            func.apply(lastThis, lastArgs);
                            hasPendingCall = false;
                        }
                    }, delay);
                }
            };
        },

        handleScroll: function () {
            if (typeof window !== 'undefined') {
                this.scrollDistance = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            }
        },

        checkScreen: function () {
            this.isMobile = window.innerWidth < 996;
        },

        // 加载 logo 资源（Vue 2 方式）
        // loadLogos() {
        //     // 方法1：使用 require.context
        //     const requireContext = require.context(
        //         '../assets/image/logo/',
        //         false,
        //         /logo_row_.*\.svg$/
        //     );

        //     const logos = {};
        //     requireContext.keys().forEach(key => {
        //         const fileName = key.replace('./', '');
        //         logos[fileName] = requireContext(key);
        //     });

        //     this.logos = logos;

        //     // 方法2：如果 logo 不多，可以硬编码
        //     // this.logos = {
        //     //     'logo_row_zh_CN.svg': require('../assets/image/logo/logo_row_zh_CN.svg'),
        //     //     'logo_row_write_zh_CN.svg': require('../assets/image/logo/logo_row_write_zh_CN.svg'),
        //     //     // ... 其他语言
        //     // };
        // }
    },
    created() {
        // 绑定节流函数
        this.handleScroll = this.throttle(this.handleScroll, 10);
        this.checkScreen = this.throttle(this.checkScreen, 10);
    }
};
</script>

<style scoped lang="scss">
.top-menu {
    position: fixed;
    left: 50%;
    top: 32rem;
    height: 66rem;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(-50%);
    font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important; /* 自动匹配用户系统默认字体 */
    scroll-behavior: smooth !important;
}

.logo-img-link{
    display: block;
    // height: 46rem;
    flex-shrink: 0;
}
.top-menu-logo {
    display: inline-block;
    height: 42rem;
    flex-shrink: 0;
}


.link-box {
    display: flex;
    align-items: center;
    gap: 32rem;
    color: var(--Text-Primary, #fff);
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 22rem;
    transition: color 0.3s;
    flex-shrink: 0;

}

.link-box a {
    color: var(--Text-Primary, #fff);
}

.top-menu-inner {
    padding: 0 200rem;
    height: 100%;
    width: auto;
    background: rgba(255, 255, 255, 0.10);
    backdrop-filter: blur(6px);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0;
    transition: all 0.3s;
    gap: 64rem;
    border-radius: 42rem;
    overflow: hidden;
    box-shadow: 0 8px 16px 2px #41465214;
}

.link-line {
    height: 16rem;
    width: 1px;
    background: #fff;
    transition: background 0.3s;
}

.colorType {
    .link-box {
        color: var(--Text-Primary, #000);

        a {
            color: var(--Text-Primary, #000);
        }
    }

    .link-line {
        background: #000;
    }

    .top-menu-inner {
        background: rgba(255, 255, 255, 0.82);
    }
}

.section-pc {}

.section-mobile {
    display: none;
}

@media (max-width: 996px) {

    .section-pc {
        display: none;
    }

    .section-mobile {
        display: block;

    }

    .top-menu-logo {
        height: 68rem;
    }

    .top-menu {
        width: 100%;
        max-width: unset;
        min-width: unset;
        // position: sticky;
        left: 0;
        top: 0;
        transform: none;
        height: 88rem;

    }

    .top-menu-inner {
        width: 100%;
        padding: 0 32rem;
        background: transparent;
        justify-content: space-between;
        transition: none;
        border-radius: 0;
        backdrop-filter: unset;
        box-shadow: none;
    }



    .icon-navigate-menu {
        font-size: 35rem;
        color: #fff;
    }




    .colorType {
        .top-menu-inner {
            background: transparent;
        }


    }

    .isTop {
        .icon-navigate-menu {
            color: #000;
        }

        .top-menu-inner {
            width: 100%;
            height: 100%;
            border-radius: 0;
            background: rgba(255, 255, 255, 0.8); // normal, black
            backdrop-filter: blur(6px);
            box-shadow: 0 8px 16px 2px #41465214;
        }
    }

    .isBlack {
        .icon-navigate-menu {
            color: #000;
        }
    }

    .isWhite {
        .icon-navigate-menu {
            color: #fff;
        }
    }

    .isTopWhite {

        .top-menu-inner {
            background: rgba(0, 0, 0, 0.8);
        }

    }



}
</style>